import React, { useEffect, useImperativeHandle, forwardRef } from "react";
import { Button, Modal, Alert, Spinner } from "react-bootstrap";
import { useSuperState } from "helpers/hooks";
import { useApp } from "common/context";

const SessionConnector = forwardRef((props, forwardedRef) => {

    const [state, setState, resetState] = useSuperState({
        error: null,
        url: null,
        show: false
    });

    const { api } = useApp();

    useImperativeHandle(forwardedRef, () => ({
        show: handleShow
    }));

    const handleShow = async url => {

        resetState();

        setState({
            show: true,
            url
        });

    };

    const handleClose = () => {

        setState({
            show: false
        });

    };

    const { error, loading, url, show } = state;

    return (
        <Modal show={show} onHide={handleClose} fullscreen>
            <Modal.Header closeButton>
                <Modal.Title>
                    Session Monitor
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <iframe
                    src={url}
                    allowFullScreen
                    className="w-100 h-100"
                >

                </iframe>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );

});

export default SessionConnector;
